import { render, staticRenderFns } from "./linkList.vue?vue&type=template&id=5faeca3d&scoped=true&"
import script from "./linkList.vue?vue&type=script&lang=ts&"
export * from "./linkList.vue?vue&type=script&lang=ts&"
import style0 from "./linkList.vue?vue&type=style&index=0&id=5faeca3d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faeca3d",
  null
  
)

export default component.exports